import { render } from "./VlogRecommandList.vue?vue&type=template&id=40acc66e&scoped=true"
import script from "./VlogRecommandList.vue?vue&type=script&lang=js"
export * from "./VlogRecommandList.vue?vue&type=script&lang=js"

import "./VlogRecommandList.vue?vue&type=style&index=0&id=40acc66e&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40acc66e"]])

export default __exports__